import {
  PageBlock,
  Stack,
  Box,
  Heading,
  Hidden,
  Divider,
  Page,
} from 'braid-design-system';
import type { ReactNode } from 'react';

import Header from 'src/components/Header/Header';
import { SiteWideFooter } from 'src/components/SiteWideFooter';

import Disclaimer from '../Disclaimer/Disclaimer';

interface PriceGuideContainerProps {
  children: ReactNode;
}

export const PriceGuideContainer = (props: PriceGuideContainerProps) => (
  <Page footer={<SiteWideFooter />} footerPosition="belowFold">
    <Header title="Sell your business" />

    <Hidden below="tablet">
      <Divider />
    </Hidden>

    <Box paddingTop="xlarge">
      <PageBlock width="medium">
        <Stack space="large">
          <Heading level="2" component="h1">
            Price guide
          </Heading>

          <Box>{props.children}</Box>

          <Disclaimer />
        </Stack>
      </PageBlock>
    </Box>
  </Page>
);
